import { useLocation } from "react-router-dom"
import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
} from "@chakra-ui/react"

const TopStepper = ({ orientation }) => {
  const steps = [
    { title: "About", description: "Contact Info" },
    { title: "Education", description: "Degree & Specialization" },
    { title: "Skills", description: "Showcase your skills" },
    { title: "Experience", description: "Roles & Responsibilities" },
    { title: "Job Preferences", description: "WFH, WFO" },
    { title: "Language", description: "Spoken Language" },
  ]

  const location = useLocation()

  const routeToStepMap = {
    "/candidate-profile": 0,
    "/candidate-profile/education": 1,
    "/candidate-profile/skills": 2,
    "/candidate-profile/experience": 3,
    "/candidate-profile/job-preferences": 4,
    "/candidate-profile/language": 5,
  }

  const activeStep = routeToStepMap[location.pathname] ?? 0

  return (
    <Stepper
      size={orientation === "horizontal" ? "sm" : "lg"}
      orientation={orientation}
      colorScheme="blue"
      index={activeStep}
      gap={orientation === "horizontal" ? "0" : "4"}
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepIndicator>
            <StepStatus complete={<StepIcon />} incomplete={<StepNumber />} active={<StepNumber />} />
          </StepIndicator>

          <Box flexShrink="0" display={orientation === "horizontal" ? { base: "none", sm: "block" } : "block"}>
            <StepTitle>{step.title}</StepTitle>
            {orientation === "vertical" && <StepDescription>{step.description}</StepDescription>}
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  )
}

export default TopStepper